
import Accordion from "./Accordion"
import AppSection from "./AppSection"
import Article from "./Article"

export default {
  components: { Accordion, AppSection, Article },
  props: {
    image: {
      type: Object,
      default: null
    },
    subHeading: {
      type: String,
      default: null
    },
    heading: {
      type: String,
      default: null
    },
    headingCentered: {
      type: Boolean,
      default: false
    },
    accordionContent: {
      type: Array,
      default: () => []
    },
    backgroundColor: {
      type: String,
      default: null
    },
    fontColor: {
      type: String,
      default: null
    },
    lineColor: {
      type: String,
      default: null
    },
    isLeftAligned: {
      type: Boolean,
      default: false
    },
    condensedWide: {
      type: Boolean,
      default: false
    },
    smallHeadingDesktop: {
      type: Boolean,
      default: false
    },
    descriptionCopy: {
      type: Array,
      default: () => []
    },
    sectionId: {
      type: String,
      default: ""
    },
  },
  computed: {
    wrapperClass() {
      return {
        columns: !this.condensedWide,
        "condensed-wide": this.condensedWide,
        "is-centered": !this.isLeftAligned
      }
    },
    hasImage() {
      return this.image && this.image.filename
    },
    focusInverted() {
      return this.backgroundColor === "#FFC300"
    },
    descriptionText() {
      return this.descriptionCopy[0] && this.descriptionCopy[0].textContent
        ? this.descriptionCopy[0].textContent
        : {}
    }
  }
}
